import { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'core/store/hooks';
import { deleteOrder, searchOrders } from '../../_redux/actions';
import { AppToastService } from 'shared/design-system/components/app-toast/app-toast.service';
import { useTranslation } from 'react-i18next';
import { filtersOrdersUsedSelector } from '../../_redux/selectors';

const useDeleteOrderById = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const filterUsed = useAppSelector(filtersOrdersUsedSelector);
  const [idToDelete, setIdToDelete] = useState<number | null>(null);

  const deleteOrderById = () => {
    if (!idToDelete) return;
    dispatch(deleteOrder(idToDelete)).then((res) => {
      if (res) {
        dispatch(searchOrders({ request: { contractOrderSearchDto: filterUsed || {} } }));
        AppToastService.success(t('common.action-completed-successfully'));
      }
    });
  };

  return {
    deleteOrderById,
    setIdToDelete,
  };
};

export default useDeleteOrderById;
